const fitSwatches = (container) => {
  const swatches = [
    ...container.querySelectorAll(":scope > .color-thumbnail"),
  ];
  if (!swatches.length) return;

  swatches.forEach((swatch) => swatch.classList.remove("is-hidden-overflow"));
  container.querySelector(":scope > .extra-colors")?.remove();

  const containerWidth = container.getBoundingClientRect().width;
  if (!containerWidth) return;

  const gap = parseFloat(getComputedStyle(container).columnGap || 8);
  const swatchWidth = swatches[0].getBoundingClientRect().width;

  let visibleCount = 0;
  for (let i = 0; i < swatches.length; i++) {
    const used = visibleCount * swatchWidth + Math.max(0, visibleCount - 1) * gap;
    if (used + (visibleCount > 0 ? gap : 0) + swatchWidth > containerWidth) break;
    visibleCount++;
  }

  if (visibleCount < swatches.length) {
    swatches.forEach((swatch, i) => {
      swatch.classList.toggle("is-hidden-overflow", i >= visibleCount);
    });

    const label = document.createElement("span");
    label.className = "extra-colors";
    container.appendChild(label);

    while (visibleCount > 0) {
      const hiddenCount = swatches.length - visibleCount;
      label.textContent = `+${hiddenCount}`;

      const used = visibleCount * swatchWidth + (visibleCount - 1) * gap;
      const labelWidth = label.getBoundingClientRect().width;

      if (used + gap + labelWidth <= containerWidth) break;
      visibleCount--;
      swatches[visibleCount].classList.add("is-hidden-overflow");
    }

    if (visibleCount === 0) label.remove();
  }
};

export const fitProductColorSwatches = () => {
  document
    .querySelectorAll(".product__colors-content")
    .forEach(fitSwatches);
};
